/*
 * @file: messages.js
 * @description: Handle staic messages for the application
 * @author: navreet
 */

const Message = {
    emptyEmail: 'Email should not be empty.',
    emptyField: 'Please enter value.',
    success: 'Success!',
    error: 'Error!',
    commonError: 'Something went wrong!',
    logout: 'Logout!',
    invalidEmail: 'Please enter a valid email.',
    confirmPassword: "Confirm Password doesn't match with New Password",
    invalidPass: 'New Password must contain:',
    invalidPass1: 'Password must contain:',

    invalid2: '   8 to 20 characters long.',
    invalid3: '   at least 1 uppercase letter.',
    invalid4: '   at least 1 lowercase letter.',
    invalid8: '   at least 1 number letter.',
    invalid5: '   at least 1 special character. (Eg @ # $).',
    invalid6: '   should not start with a number.',
    invalid7: '   should not contain any spaces.',
    // invalid2:"2 upper case(A-Z)",
    // invalid3:"1 special character(!@#$&*) ",
    // invalid4: "2 digits(0-9)",
    // invalid5:"3 lowercase letters(a-z)",
    notValidPrice: 'Please enter valid Price',
    notValidQuantity: 'Please enter valid Quantity',
    notValidPoints: 'Please enter valid Points',
    required: '*required',
    emptyPassword: 'Password should not be empty.',
    currentPassword: 'Current Password should not be empty.',
    invalidOTP: 'Please enter a valid 4 digit OTP.',
    zipcodeFieldLength: 'Please enter valid zip code.',
    emptyOtp: 'OTP should not be empty',
    nameField: 'Merchant Name should not be empty.',
    merchantNameField: 'Merchant Name should not be empty',
    adminFirstNameField: 'First Name should not be empty',
    adminLastNameField: 'Last Name should not be empty',
    streetField: 'Street Address should not be empty.',
    streetNumeric: 'Street Address should be alphanumeric.',
    streetValid: 'Please Enter a valid Street Address',

    cityField: 'City should not be empty.',
    cityValid: 'Please Enter a valid City',
    merchantValid: 'Please Enter a valid Merchant Name',
    firstValid: 'Please Enter a valid First Name',
    lastValid: 'Please Enter a valid Last Name',

    stateField: 'State should not be empty.',
    zipcodeField: 'Zip Code should not be empty.',

    productNameField: 'Product Name should not be empty.',
    hivePointsField: 'Hive Points should not be empty.',
    quantityField: 'Quantity should not be empty.',
    StartDateField: 'Start Date should not be empty.',
    EndDateField: 'End Date should not be empty.',
    productPrice: 'Product Price should not be empty.',
    productDescription: 'Product Description should not be empty.',
    passMatch: "Confirm Password and Password doesn't match",
    confirmPasswordNew: 'Confirm Password should not be empty.',
    newPassword: 'New Password should not be empty.',
    Password: 'Password should not be empty.',
    facebookContent: "Facebook content should not be empty",
    instagramContent: "Instagram content should not be empty",
    twitterContent: "Twitter content should not be empty",
    facebook: "Facebook content should be valid",
    instagram: "Instagram content should be valid",
    twitter: "Twitter content should be valid",

    couponNameField: 'Coupon Name should not be empty',
    couponRedemptionLinkField: 'Redemption Link should not be empty',
    weekendPointField: 'Weekend Points should not be empty',
    rewardPointField: 'Registration Points should not be empty',
    contentField: 'This field can not be empty',
    // couponDescriptionField: 'Coupon Description should not be empty',
    notValidUrl: 'Please Enter a valid URL',
    notValidStartDate: 'Invalid Start Date',
    notValidEditorContent: 'notValidEditorContent'
}

module.exports = Message
